import { Component, Input } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { OnInit } from "@angular/core";

@Component({
  selector: "emprestimo-error",
  templateUrl: "./emprestimo-error.component.html",
  styleUrls: ["./emprestimo-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class EmprestimoErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsLoan: string[] = [
    "typeAction",
    "portfolioDocument",
    "portfolioName",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "broker",
    "clearingAgent",
    "loanType",
    "isReversibleByDonor",
    "dueDate",
    "contractNumber",
    "paperCode",
    "stocksAmount",
    "finalGraceDate",
    "remunerationRate",
    "commissionFee",
    "settlementPeriodicity",
    "operationCode",
    "loanOperationTypeId",
    "marginCredit",
    "priceSettlementReference",
    "annotations",
  ];

  ngOnInit(): void {}
}
